import Swiper from 'swiper';

function generateUUID() { // Public Domain/MIT
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function'){
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
}

var $swiperElements = $('.swiper-container');
if($swiperElements.length > 0) {
    $swiperElements.each(function() {
        let uuid = generateUUID();
        let maxSlides = $(this)[0].hasAttribute('data-slides') ? parseInt($(this).attr('data-slides'), 10) : 4;
        $(this).attr('data-id', uuid);

        var swiper = new Swiper($(this)[0], {
            slidesPerView: maxSlides,
            spaceBetween: 15,
            autoHeight: true,
            loop: true,
            navigation: {
                nextEl: '[data-id="'+uuid+'"] .swiper-button-next',
                prevEl: '[data-id="'+uuid+'"] .swiper-button-prev'
            },
            breakpoints: {
                1200: {
                    slidesPerView: maxSlides,
                    spaceBetween: 15
                },
                1024: {
                    slidesPerView: 4,
                    spaceBetween: 15
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 15
                },
                480: {
                    slidesPerView: 2,
                    spaceBetween: 15
                },
                320: {
                    slidesPerView: 1,
                    spaceBetween: 15
                }
            }
        });

        $(document).on('click', '[data-id="'+uuid+'"] .swiper-button-prev', function() {
            swiper.slidePrev();
        });

        $(document).on('click', '[data-id="'+uuid+'"] .swiper-button-next', function() {
            swiper.slideNext();
        });
    });
}

$(document).ready(function() {
    $('.lazyload-bg').each(function() {
        var lazy = $(this);
        var src = lazy.attr('data-src');

        lazy.css('background-image', 'url("' + src + '")');
        lazy.removeAttr('data-src');
        lazy.removeClass('lazyload-bg');
    });
});
